var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyCartIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0H360V640H0z",
    transform: "translate(-120 -260)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-120 -260) translate(120 258)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#DBDBDB",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#E83647",
    strokeWidth: 2.5,
    transform: "translate(26 40)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M30.192 9.324h22.36c.136 0 .271.011.405.033 1.171.193 1.94 1.17 1.717 2.181l-4.112 18.649c-.194.88-1.085 1.516-2.122 1.516H22.407c-1.037 0-1.927-.636-2.121-1.516L12.418 0H0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.91,
    cy: 40.03,
    rx: 3.231,
    ry: 3.213
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.743,
    cy: 40.03,
    rx: 3.231,
    ry: 3.213
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M34.465 25.919L50.697 25.919M33.172 20.35L52.367 20.35M31.88 14.888L52.989 14.888"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCartIcon);
export default __webpack_public_path__ + "static/media/empty-cart-icon.9f5ce529e8665ae894c4dee11ca1cf22.svg";
export { ForwardRef as ReactComponent };